import React from 'react';

interface Colleague {
  userId: string;
  topics: Array<{
    topicId: string;
    title: string;
    presentedAt: string;
    submittedAt: string;
  }>;
}

interface ImpactedColleaguesModalProps {
  isOpen: boolean;
  onClose: () => void;
  colleagues: Colleague[];
}

const ImpactedColleaguesModal: React.FC<ImpactedColleaguesModalProps> = ({
  isOpen,
  onClose,
  colleagues
}) => {
  if (!isOpen) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '24px',
          maxWidth: '600px',
          width: '90%',
          maxHeight: '80vh',
          overflow: 'auto',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>Colleagues Impacted: {colleagues.length}</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {colleagues.length === 0 ? (
          <p style={{ color: '#64748b', textAlign: 'center', padding: '20px' }}>
            No colleagues have rated your topics yet.
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {colleagues.map((colleague) => (
              <div 
                key={colleague.userId}
                style={{
                  display: 'flex',
                  padding: '16px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  backgroundColor: '#f8fafc'
                }}
              >
                <div style={{ minWidth: '150px', paddingRight: '16px' }}>
                  <a
                    href={`https://phonetool.amazon.com/users/${colleague.userId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#2563eb',
                      textDecoration: 'none',
                      fontWeight: '500',
                      fontSize: '14px'
                    }}
                  >
                    {colleague.userId}
                  </a>
                </div>
                <div style={{ flex: 1 }}>
                  {colleague.topics.map((topic, index) => (
                    <div key={topic.topicId} style={{ marginBottom: index < colleague.topics.length - 1 ? '8px' : '0' }}>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#1e293b' }}>
                        • {topic.title}
                      </div>
                      <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
                        Presented: {topic.presentedAt ? 
                          new Date(topic.presentedAt).toLocaleDateString('en-US', { 
                            year: 'numeric', 
                            month: 'short', 
                            day: 'numeric' 
                          }) : 
                          'Not yet presented'
                        } | Feedback: {new Date(topic.submittedAt).toLocaleDateString('en-US', { 
                          year: 'numeric', 
                          month: 'short', 
                          day: 'numeric' 
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpactedColleaguesModal;
